import * as actions from './actions';
import * as chatTypes from '../chat/actionTypes';

export type State = { message: string } | null;

// HACK: Dummy type to get the fix out.
type RestartAction = { type: string };

type Actions = actions.SetErrorAction | RestartAction;

function reducer(state: State = null, action: Actions): State {
  switch (action.type) {
    case actions.ERROR_MESSAGE: {
      const { payload } = action as actions.SetErrorAction;
      if (payload) {
        return { message: payload.message };
      } else {
        return null;
      }
    }
    case chatTypes.RESTART_CHAT_REQUEST: {
      return null;
    }
    case actions.RESET_ERROR: {
      return null;
    }
  }
  return state;
}

export default reducer;
